export default __webpack_public_path__ + "static/media/sort-asc.89a1b1ab.svg";